// Whenever changing these, css needs to be recalculated on
// card size depending on viewport, look at the _default css file
export const PAGE_SIZES = {
    SMALL: 2,
    MED: 3,
    LARGE: 5,
};

// Needs to match the SASS definition $default-page-size in the file /styles/themes/default.scss
export const DEFAULT_PAGE_SIZE = 100;
